import React, { useEffect, useState } from "react";
import MainNav from "@/components/MainNav";
import FooterAdmin from "@/components/FooterAdmin";
import { isAuthenticated, me } from "@/lib/utils";

const AdminPrivateLayout = ({ children }: { children: React.ReactNode }) => {
    const [isLoading, setIsLoading] = useState(true);  // Add a loading state

    useEffect(() => {
        if (!isAuthenticated()) {
            window.location.href = "/admin/login";
            return;
        }

        const sessionUser = me();
        if (!sessionUser?.isAdmin) {
            window.location.href = "/admin/login";
            return;
        }

        setIsLoading(false); // Set loading to false when authenticated & admin
    }, []);  // Trigger effect whenever authentication state changes

    if (isLoading) {
        return null; // Render nothing while the authentication check is in progress
    }

    return (
        <div className="min-h-screen flex flex-col bg-gray-50">
            {/* Navigation */}
            <MainNav />

            {/* Main Content */}
            <main className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                {children}
            </main>

            {/* Footer */}
            <FooterAdmin />
        </div>
    );
};

export default AdminPrivateLayout;